// extracted by mini-css-extract-plugin
export default {"brown":"header_brown__mlRWx","loginBtn":"header_loginBtn__24cnG","nav":"header_nav__xAJVM"};